<template>
  <div class="reserve-tabs-conrainer">
    <div
      @click="ChangeTab('new')"
      :class="['tab', activeTab == 'new' ? 'tab-active' : '']"
    >
      <img src="/icons/tabs/new.svg" alt="">
      {{ $t("tabs.new") }}
      <span :style="{
        'color': hasPendingReserves ? '#e2223b' : '#A4A3A1'
      }">({{ counters.new }})</span>
    </div>
    <div
      @click="ChangeTab('performed')"
      :class="['tab', activeTab == 'performed' ? 'tab-active' : '']"
    >
     <img src="/icons/tabs/processing.svg" alt="">
      {{ $t("tabs.processing") }}
      <span>({{ counters.performed }})</span>
    </div>
    <div
      @click="ChangeTab('calendar')"
      :class="['tab', activeTab == 'calendar' ? 'tab-active' : '']"
    >
      <img src="/icons/tabs/calendar.svg" alt="">
      {{ $t("tabs.calendar") }}
      <span>({{ counters.calendar }})</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activeTab: {
      type: String,
      default: "new",
    },
    counters: {
      type: Object,
      default: () => {
        return { new: 0, performed: 0, calendar: 0 };
      },
    },
  },
  methods: {
    ChangeTab(tab) {
      this.$emit("onTabChange", tab);
    },
  },
  computed: {
    hasPendingReserves() {
      return !!this.counters.new;
    }
  }
};
</script>
<style scoped>
.reserve-tabs-conrainer {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  height: 10.09vh;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: rgba(29, 29, 27, 0.9);
  backdrop-filter: blur(7px);
}
.tab {
  color: #908f8d;
  font-size: 1.6009vh;
  line-height: 1.7241379310344827vh;
  display: flex;
  width: 15.147783251231525vh;
  flex-direction: column;
  align-items: center;
  margin-top: 1.3546798029556648vh;
}
.tab img {
  margin: 0 auto 1.2vw;
}
.tab-active {
  color: #ededed;
}
.tab-active svg path {
  fill: #ededed;
}
.tab span {
  line-height: 1.9472906403940885vh;
}
@media screen and (min-width: 765px) {
  .reserve-tabs-conrainer {
    height: 5.694vw;
  }
  .tab svg {
    margin-bottom: 0.347vw;
  }
  .tab {
    color: #ededed;
    margin-top: 0.903vw;
  }
  .tab svg path {
    fill: #ededed;
  }
  .tab span {
    font-size: 0.894vw;
  }
}
</style>